import Vue from "vue";
import excel from "vue-excel-export";
import breadcrumbComp from "../../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../../../components/utility/js/encrypt-utility";
import AddFavourite from "../../../utility/js/addFav";
import Utility from "../../../../shared/utility";
import exportLimit from "../../../common/export-limit.vue";
import inventoryService from "../../js/inventory-service";
Vue.use(excel);
export default {
  data: () => ({
    mainPage: "",
    subPage: "",
    subPageUrl: "",
    appPageName: "",
    pageUrl: "",
    showTab: false,
    backSlashParent: true,
    excelFileName: "",
    compCalled: false,
    showAdd: false,
    route: "",
    routeName: "",
    favouriteList: [],
    isFormValid: false,
    actionList: [],
    totalRecords: 0,
    showBinList: false,
    activeTab: 0,
    tabs: [
      "Part Type",
      "Business",
      "Parent Class",
      "Sub Class",
      "Warehouse",
      "Location",
      "Part Number",
      "Bin",
    ],
    userId: EncryptUtility.localStorageDecrypt("userID"),
    refresh: true,
    projectList: [],
    scopeList: [],
    selectedItems: [],
    scopeDataList: [],
    reconciliationList: [],
    partTypeList: [],
    binList: [],
    businessList: [],
    parentList: [],
    warehouseList: [],
    locationList: [],
    subClassList: [],
    partTempList: [],
    binTempList: [],
    totalBusiness: 0,
    totalparentClass: 0,
    totalsubClass: 0,
    totalWarehouse: 0,
    totalWorkCenter: 0,
    disableTab: true,
    disableSubClassTab: true,
    partNumberSwitch: false,
    binSwitch: false,
    allPart: false,
    allBin: false,
    loc: "",
    rowNum: "",
    binNumber: "",
    minBin: "",
    maxBin: "",
    search: "",
    rowDes: "",
    partNum: "",
    binNum: "",
    scopeListHeader: [
      {
        text: "Scope",
        align: "start",
        value: "Scope",
        class: "primary customwhite--text",
      },
      {
        text: "Project",
        align: "start",
        value: "Project",
        class: "primary customwhite--text",
      },
      {
        text: "Type",
        align: "start",
        value: "Type",
        class: "primary customwhite--text",
      },
      {
        text: "Actions",
        value: "actions",
        class: "primary customwhite--text",
      },
    ],
    partTypeHeader: [
      {
        text: "Part Type",
        align: "start",
        value: "Part Type",
        class: "primary customwhite--text",
      },
    ],
    warehouseHeader: [
      {
        text: "Warehouse",
        align: "start",
        value: "Warehouse",
        class: "primary customwhite--text",
      },
    ],
    businessHeader: [
      {
        text: "",
        align: "start",
        value: "Action",
        class: "primary customwhite--text",
      },
      {
        text: "Business",
        align: "start",
        value: "Business",
        class: "primary customwhite--text",
      },
    ],
    binHeader: [
      {
        text: "Bin",
        align: "start",
        value: "Bin",
        class: "primary customwhite--text",
      },
    ],
    locationHeader: [
      {
        text: "Location",
        align: "start",
        value: "Location",
        class: "primary customwhite--text",
      },
    ],
    subClassHeader: [
      {
        text: "Sub Class",
        align: "start",
        value: "Class",
        class: "primary customwhite--text",
      },
    ],
    parentHeader: [
      {
        text: "Parent Class",
        align: "start",
        value: "Parent Class",
        class: "primary customwhite--text",
      },
    ],
    required: [(v) => !!v || "Field is required"],
    controlValidataion: [
      (v) => !!v || "Field is required",
      (v) => /^(?!.*&).+$/.test(v) || "Field should not contain & symbol",
      (v) =>
        /^(?:[ A-Za-z0-9\s\S]){5,25}$/.test(v) ||
        "Please enter at least one text or number, Field should be greater than 5 characters and less than 25 characters",
    ],
    accuracyValidation: [
      (v) => parseInt(v) >= 0 || "Field is required",
      (v) =>
        /^[1-9][0-9]?(\.[0-9]{1,2})?$/.test(v) ||
        "Between 1 to 99 Upto 2 decimal places are allowed",
    ],
    min1Rule: [
      (v) => parseInt(v) >= 0 || "Field should be greather than 0",
      (v) => !!v || "Field is required",
    ],
    max999Rule: [
      (v) => parseInt(v) <= 999 || "Field should be less than than 999",
      (v) => !!v || "Field is required",
    ],
    binRule: [
      (v) => !!v || "Field is required",
      (v) =>
        /^[A-Z]{1,2}[0-9]{1,3}$/.test(v) ||
        "Please enter the correct format Eg:-AA-111,AA11",
    ],
    only8CharAllowed: [
      (v) => /^(?!.*&).+$/.test(v) || "Field should not contain & symbol",
      (v) => !!v || "Field is required",
      (v) => (v || "").length == 8 || "Field should have 8 characters",
    ],
    backSlash: true,
    partNumList: [],
    showPartNumList: false,
    selectedPartItems: [],
    partHeader: [
      {
        text: "Part Number",
        align: "start",
        value: "Part Number",
        class: "primary customwhite--text",
      },
      {
        text: "Part Description",
        align: "start",
        value: "Part Description",
        class: "primary customwhite--text",
      },
    ],
    saveObj: {
      Project: 0,
      PiTypeKey: 0,
      Control: "",
      AccuracyGoal: 0,
      Unlock: "",
      Zone: "",
      PreCounts: false,
      ReconcileMethod: 0,
      Serialized: false,
      NonSerialized: false,
      Business: [],
      ParentClass: [],
      SubClass: [],
      Warehouse: [],
      Location: [],
      WorkCenter: [],
      PartNumber: [],
      Bin: [],
    },
    totalPartCount: 0,
    editObj: {
      controlID: 0,
      json: {
        ControlID: 0,
        Control: "",
        Project: "",
        PiTypeKey: "",
        StatusKey: "",
        Unlock: "",
        Zone: "",
        AccuracyGoal: "",
        PreCounts: "",
        ReconcileMethod: -1,
        PartType: [],
        Serialized: "N",
        NonSerialized: "N",
        Business: [],
        SubBusiness: [],
        ParentClass: [],
        SubClass: [],
        Warehouse: [],
        WorkCenter: [],
        PartNumber: [],
        Bin: [],
      },
      user_key: 0,
      isnew: 1,
    },
  }),
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
  },
  async mounted() {
    let obj = {
      user_id: this.userId,
      pass: 1,
    };
    let resp = await inventoryService.getAddData("post", obj);
    this.projectList = resp.Projects;
    this.scopeList = resp.Scope;
    this.reconciliationList = resp.Type;
  },
  methods: {
    actionSetter(action) {
      return Utility.actionSetter(this.actionList, action);
    },
    async onChangeType() {
      this.showTab = true;
      this.editObj.json.ControlID = 0;
      this.editObj.json.Control = "";
      this.editObj.json.StatusKey = "";
      this.editObj.json.Unlock = "";
      this.editObj.json.Zone = "";
      this.editObj.json.AccuracyGoal = "";
      this.editObj.json.ReconcileMethod = -1;
      this.editObj.json.PartType = [];
      this.editObj.json.Serialized = "N";
      this.editObj.json.NonSerialized = "N";
      this.editObj.json.Business = [];
      this.editObj.json.SubBusiness = [];
      this.editObj.json.ParentClass = [];
      this.editObj.json.SubClass = [];
      this.editObj.json.Warehouse = [];
      this.editObj.json.WorkCenter = [];
      this.editObj.json.PartNumber = [];
      this.saveObj.Control = "";
      this.saveObj.AccuracyGoal = 0;
      this.saveObj.Unlock = "";
      this.saveObj.Zone = "";
      this.saveObj.PreCounts = false;
      this.saveObj.ReconcileMethod = 0;
      this.saveObj.Serialized = false;
      this.saveObj.NonSerialized = false;
      this.allPart = false;
      this.partNumberSwitch = false;
      this.partNum = "";
      this.binSwitch = false;
      this.allBin = false;
      this.rowDes = "";
      this.minBin = "";
      this.maxBin = "";
      this.binNumber = "";
      this.activeTab = 0;
      this.$refs.addScopeForm.resetValidation();
      this.editObj.json.Project = this.saveObj.Project;
      this.editObj.json.PiTypeKey = this.saveObj.PiTypeKey;
      this.editObj.user_key = this.userId;
      let submitObj = JSON.parse(JSON.stringify(this.editObj));
      submitObj.json = JSON.stringify(submitObj.json);
      let resp = await inventoryService.postScopeEdit("post", submitObj, false);
      this.partTypeList = resp.parttype;
      this.businessList = resp.Business;
      this.totalBusiness = this.businessList?.length;
      this.totalPartCount = this.partTypeList.length;
    },
    shouldDisableTab(tab) {
      const disabledTabs = [
        "Warehouse",
        "Location",
        "Parent Class",
        "Sub Class",
        "Part Number",
        "Bin",
      ];
      if (!this.disableTab || !disabledTabs.includes(tab)) {
        return false;
      }
      if (tab === "Sub Class") {
        return (
          !this.editObj.ParentClass || this.editObj.ParentClass.length === 0
        ); // Disabled by default unless ParentClass is selected
      }
      if (tab == "Part Number") {
        return !this.editObj.Location || this.editObj.Location.length === 0; // Disabled by default unless SubClass is selected
      }
      return true;
    },
    async onChangeBusinessSelect() {
      this.disableTab = false;
      let jsonObj = this.apiCallForPostEdit();
      let submitObj = {
        user_id: this.userId,
        json: JSON.stringify(jsonObj),
        controlID: 0,
        isnew: 1,
      };
      let resp = await inventoryService.postScopeEdit("post", submitObj, false);
      this.parentList = resp.Parentclass;
      this.locationList = resp.Location;
      this.warehouseList = resp.Warehouse;
      this.totalparentClass = this.parentList?.length;
      this.totalWarehouse = this.warehouseList?.length;
      this.totalWorkCenter = this.locationList?.length;
      this.editObj.json.ParentClass = this.parentList;
      this.subClassList = resp.Class;
      this.totalsubClass = this.subClassList.length;
      this.editObj.json.Business.length < 0
        ? (this.disableTab = true)
        : (this.disableTab = false);
    },
    async onChangeParentSelect() {
      this.disableTab = false;
      let jsonObj = this.apiCallForPostEdit();
      let submitObj = {
        user_id: this.userId,
        json: JSON.stringify(jsonObj),
        controlID: 0,
        isnew: 1,
      };
      let resp = await inventoryService.postScopeEdit("post", submitObj, false);
      this.subClassList = resp.Class;
      this.totalsubClass = this.subClassList.length;
      // this.editObj.json.ParentClass.length < 0
      //   ? (this.disableTab = true)
      //   : (this.disableTab = false);
    },
    async onChangeSubClassSelect() {
      this.disableTab = false;
      let jsonObj = this.apiCallForPostEdit();
      let submitObj = {
        user_id: this.userId,
        json: JSON.stringify(jsonObj),
        controlID: 0,
        isnew: 1,
      };
      let resp = await inventoryService.postScopeEdit("post", submitObj, false);
      this.warehouseList = resp.Warehouse;
      this.totalWarehouse = this.warehouseList.length;
      this.locationList = resp.Location;
      this.totalWorkCenter = this.locationList?.length;
      this.editObj.json.SubClass.length < 0
        ? (this.disableTab = true)
        : (this.disableTab = false);
    },
    async onChangePartTypeSelect() {
      this.editObj.json.Warehouse = [];
      this.editObj.json.Location = [];
      this.editObj.json.Business = [];
      this.editObj.json.ParentClass = [];
      this.editObj.json.SubClass = [];
      this.disableTab = false;
      let jsonObj = this.apiCallForPostEdit();
      let submitObj = {
        user_id: this.userId,
        json: JSON.stringify(jsonObj),
        controlID: 0,
        isnew: 1,
      };
      let resp = await inventoryService.postScopeEdit("post", submitObj, false);
      this.businessList = resp.Business;
      this.totalBusiness = this.businessList.length;
      this.parentList = resp.Parentclass;
      this.totalparentClass = this.parentList.length;
      this.warehouseList = resp.Warehouse;
      this.totalWarehouse = this.warehouseList.length;
      this.locationList = resp.Location;
      this.totalWorkCenter = this.locationList?.length;
      this.editObj.json.PartType.length < 0
        ? (this.disableTab = true)
        : (this.disableTab = false);
    },
    async onChangeWarehouseSelect() {
      this.disableTab = false;
      let jsonObj = this.apiCallForPostEdit();
      let submitObj = {
        user_id: this.userId,
        json: JSON.stringify(jsonObj),
        controlID: 0,
        isnew: 1,
      };
      let resp = await inventoryService.postScopeEdit("post", submitObj, false);
      this.locationList = resp.Location;
      this.totalWorkCenter = this.locationList?.length;
      this.editObj.json.Warehouse.length < 0
        ? (this.disableTab = true)
        : (this.disableTab = false);
    },
    async onClickValidatePart() {
      let scope = JSON.parse(JSON.stringify(this.saveObj));
      scope.NonSerialized ? "Y" : "N";
      scope.Serialized ? "Y" : "N";
      scope.PreCounts ? "Y" : "N";
      let jsonObj = this.apiCallForPostEdit();
      let validateObj = {
        json: JSON.stringify(jsonObj),
        user_id: this.userId,
        part_num: this.partNum,
      };
      let resp = await inventoryService.postValidate(
        "post",
        validateObj,
        false
      );
      resp ? jsonObj.PartNumber.push(resp.part_key) : "";
      let submitObj = {
        user_id: this.userId,
        json: JSON.stringify(jsonObj),
        controlID: 0,
        isnew: 1,
      };
      let scopeRes = await inventoryService.postScopeEdit(
        "post",
        submitObj,
        false
      );
      this.partNumList = scopeRes.Parts;
      this.selectedPartItems = this.partNumList;
      this.showPartNumList = true;
      this.partNum = "";
    },
    async onClickValidateBin(loc) {
      let isValid = false;
      this.loc = loc;
      const numFormRef = Array.isArray(this.$refs.numForm)
        ? this.$refs.numForm[0]
        : this.$refs.numForm;
      const binRangeFormRef = Array.isArray(this.$refs.binRangeForm)
        ? this.$refs.binRangeForm[0]
        : this.$refs.binRangeForm;
      if (loc === "Num") {
        if (numFormRef?.validate) {
          isValid = await numFormRef.validate(); // Validate 'Num' form
        } else {
          console.warn("numFormRef.validate is not a function");
        }

        this.rowDes = "";
        this.minBin = "";
        this.maxBin = "";
        binRangeFormRef?.resetValidation?.();
      } else {
        if (binRangeFormRef?.validate) {
          isValid = await binRangeFormRef.validate(); // Validate 'Range' form
        } else {
          console.warn("binRangeFormRef.validate is not a function");
        }

        this.binNum = "";
        numFormRef?.resetValidation?.();
      }

      if (isValid) {
        let binObj = {
          pass: loc == "Num" ? 2 : 1,
          controlID: 0,
          row: this.rowDes,
          low: this.minBin,
          high: this.maxBin,
          bin: this.binNumber,
        };

        let resp = await inventoryService.postValidateBin(
          "post",
          binObj,
          false
        );

        if (resp) {
          let jsonObj = this.apiCallForPostEdit();
          resp ? jsonObj.Bin.push(...resp.map((item) => item.bin_key)) : "";
          let submitObj = {
            user_id: this.userId,
            json: JSON.stringify(jsonObj),
            controlID: 0,
            isnew: 1,
          };
          let scopeRes = await inventoryService.postScopeEdit(
            "post",
            submitObj,
            false
          );
          this.binList = scopeRes.Bin;
          this.selectedItems = this.binList;
          this.binSwitch = true;
          this.showBinList = true;
        }
      }
    },
    async onChangePartNum() {
      this.showPartNumList = true;
      this.partNum = "";
      this.partTempList = this.selectedPartItems.map((item) => item.part_key);
      this.partNumList = this.selectedPartItems;
    },
    onChangeBin() {
      this.binTempList = this.selectedItems.map((item) => item.bin_key);
      this.binList = this.selectedItems;
    },
    apiCallForPostEdit() {
      const mapKeys = (items, key) => items?.map((item) => item[key]);
      let jsonObj = {
        Project: this.saveObj.Project,
        PiTypeKey: this.saveObj.PiTypeKey,
        ControlID: 0,
        Control: this.saveObj.Control,
        AccuracyGoal: this.saveObj.AccuracyGoal,
        Unlock: this.saveObj.Unlock,
        Zone: this.saveObj.Zone,
        PreCounts: this.saveObj.PreCounts ? "Y" : "N",
        ReconcileMethod: this.saveObj.ReconcileMethod,
        Serialized: this.saveObj.Serialized ? "Y" : "N",
        NonSerialized: this.saveObj.NonSerialized ? "Y" : "N",
        PartType:
          this.totalPartCount == this.editObj?.json?.PartType?.length
            ? ["All"]
            : mapKeys(this.editObj?.json?.PartType, "ptype_key"),
        Business:
          this.totalBusiness == this.editObj?.json?.Business?.length
            ? ["All"]
            : mapKeys(this.editObj?.json?.Business, "bu_key"),
        ParentClass:
          this.totalparentClass == this.editObj?.json?.ParentClass?.length
            ? ["All"]
            : mapKeys(this.editObj?.json?.ParentClass, "parent_class_key"),
        SubClass:
          this.totalsubClass == this.editObj?.json?.SubClass?.length
            ? ["All"]
            : mapKeys(this.editObj?.json?.SubClass, "class_key"),
        Warehouse:
          this.totalWarehouse == this.editObj?.json?.Warehouse?.length
            ? ["All"]
            : mapKeys(this.editObj?.json.Warehouse, "ware_key"),
        WorkCenter:
          this.totalWorkCenter == this.editObj?.json?.Location?.length
            ? ["All"]
            : mapKeys(this.editObj?.json.Location, "loc"),
        PartNumber: this.allPart ? ["All"] : this.partTempList,
        Bin: this.allBin ? ["All"] : this.binTempList,
      };
      return jsonObj;
    },
    async onClickSubmit() {
      const validateSelection = (key, tabId, message) => {
        if (this.editObj?.json[key]?.length == 0) {
          document.getElementById(tabId).click();
          let Alert = {
            type: "error",
            isShow: true,
            message: message,
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        } else {
          return false;
        }
      };
      if (
        validateSelection("PartType", "tab-0", "Select at least one Part Type")
      );
      if (
        validateSelection("Business", "tab-1", "Select at least one Business")
      );
      if (this.disableTab) {
        if (
          validateSelection(
            "ParentClass",
            "tab-2",
            "Select at least one Parent Class"
          )
        );
        if (
          validateSelection(
            "SubClass",
            "tab-3",
            "Select at least one Sub Class"
          )
        );
        if (
          validateSelection(
            "Warehouse",
            "tab-4",
            "Select at least one Warehouse"
          )
        );
        if (
          validateSelection("Location", "tab-5", "Select at least one Location")
        );
      }
      if (this.$refs.addScopeForm.validate()) {
        let jsonObj = this.apiCallForPostEdit();
        const submitObj = {
          user_id: this.userId,
          json: JSON.stringify(jsonObj),
        };
        const resp = await inventoryService.submitScope(
          "post",
          submitObj,
          false
        );
        let Alert = {
          type: "success",
          isShow: true,
          message: resp[0]?.Message,
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        if (resp[0]?.control_id) {
          this.$router.push(
            `/scope-manager-edit/${btoa(resp[0]?.control_id.toString())}`
          );
        }
      }
    },
    resetFunction() {
      this.$refs.addScopeForm.resetValidation();
      this.activeTab = 0;
      this.businessList = [];
      this.partTypeList = [];
      this.parentList = [];
      this.warehouseList = [];
      this.locationList = [];
      this.subClassList = [];
      this.partNumList = [];
      this.binList = [];
      this.selectedPartItems = [];
      this.selectedItems = [];
      this.totalBusiness = 0;
      this.totalparentClass = 0;
      this.totalsubClass = 0;
      this.totalWarehouse = 0;
      this.totalWorkCenter = 0;
      this.totalPartCount = 0;
      this.allBin = false;
      this.partNumberSwitch = false;
      this.allPart = false;
      this.binSwitch = false;
      this.partNum = "";
      this.binNum = "";
      this.showPartNumList = false;
      this.showBinList = false;
      // Clear selection model before resetting editObj
      if (this.editObj && this.editObj.json) {
        this.editObj.json.Business = [];
        this.editObj.json.PartType = [];
        this.editObj.json.ParentClass = [];
        this.editObj.json.SubClass = [];
        this.editObj.json.Warehouse = [];
        this.editObj.json.Location = [];
        this.editObj.json.PartNumber = [];
        this.editObj.json.Bin = [];
        this.$nextTick(() => {});

      }
      // Now reset editObj and saveObj
      this.editObj = {
        controlID: 0,
        json: {
          ControlID: 0,
          Control: "",
          Project: "",
          PiTypeKey: "",
          StatusKey: "",
          Unlock: "",
          Zone: "",
          AccuracyGoal: "",
          PreCounts: "",
          ReconcileMethod: -1,
          PartType: [],
          Serialized: "N",
          NonSerialized: "N",
          Business: [],
          SubBusiness: [],
          ParentClass: [],
          SubClass: [],
          Warehouse: [],
          WorkCenter: [],
          PartNumber: [],
          Bin: [],
        },
        user_key: this.userId,
        isnew: 1,
      };
      this.saveObj = {
        Project: 0,
        PiTypeKey: 0,
        Control: "",
        AccuracyGoal: 0,
        Unlock: "",
        Zone: "",
        PreCounts: false,
        ReconcileMethod: 0,
        Serialized: false,
        NonSerialized: false,
        Business: [],
        ParentClass: [],
        SubClass: [],
        Warehouse: [],
        Location: [],
        WorkCenter: [],
        PartNumber: [],
        Bin: [],
      };
      this.partNumList = [];
      this.binList = [];
      this.partNum = "";
      this.binNum = "";
      this.showPartNumList = false;
      this.showBinList = false;
      this.showTab = false;
        this.$nextTick(() => {
          this.showTab = false;
        });
    },
    onChangePartNumSwitch() {
      if (!this.partNumberSwitch) {
        this.partNum = "";
        this.partNumList = [];
        this.selectedPartItems = [];
        this.showPartNumList = false;
      }
    },
    onChangeBinSwitch() {
      if (!this.binSwitch) {
        this.binNum = "";
        this.binList = [];
        this.selectedItems = [];
        this.showBinList = false;
        this.rowDes = "";
        this.minBin = "";
        this.maxBin = "";
        this.binNumber = "";
      }
    },
  },
  components: {
    breadcrumbComp,
    exportLimit,
  },
};
